
    import { Component, Emit, Prop, Vue } from 'nuxt-property-decorator';
    import OptionsFieldsMultiselect from '@/components/editor/options/fields/OptionsFieldsMultiselect.vue';
    import { namespace } from 'nuxt-property-decorator';

    const pages = namespace('pages');
    @Component({
        components: { OptionsFieldsMultiselect }
    })
    export default class OptionsFieldsPagesMultiselect extends Vue {
        @Prop() options: [];

        @pages.State pages;
        @pages.State groups;
        @pages.Action fetchAllPages;
        @pages.Action fetchAllGroups;

        async created() {
            const promises: Promise<any>[] = [];

            if (this.pages && this.pages.length > 0) promises.push(this.fetchAllPages());
            if (this.groups && this.groups.length > 0)
                promises.push(this.fetchAllGroups());

            await Promise.all(promises);
        }

        @Emit('input')
        changeMultiselect(val) {
            return val;
        }

        getBlogPages() {
            const pages: { [key: string]: string }[] = [];

            this.pages.forEach(page => {
                if (page.options.pageType === 'blog') {
                    pages.push({
                        id: page.id,
                        name: page.options.title,
                        href: this.makePageLink(page.options)
                    });
                }
            });

            return pages;
        }

        makePageLink({ group, slug, buildUrlFromRoot }) {
            const link =
                group && !buildUrlFromRoot
                    ? `/${group.options.slug}/${slug}`
                    : `/${slug}`;
            return link;
        }
    }
